import {
  FormControl,
  FormHelperText,
  MenuItem,
  TextField,
  Typography
} from '@mui/material'
import React from 'react'
import { Controller, useFormContext, get } from 'react-hook-form'
import { Waypoint } from 'react-waypoint'

export const ControlledSelectField = ({
  name,
  defaultValue = '',
  label,
  helperText,
  menuItems,
  fetchable = false,
  fetchMore,
  fetching = false,
  ...rest
}) => {
  const { control, formState } = useFormContext()

  if (menuItems === undefined || menuItems.length < 1) {
    return null
  }

  const error = get(formState.errors, name)
  const hasError = error !== undefined

  return (
    <FormControl fullWidth size='small'>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field: { onChange, value, onBlur, ref } }) => (
          <TextField
            onChange={onChange}
            value={value}
            label={label}
            variant='outlined'
            size='small'
            select
            inputRef={ref}
            onBlur={onBlur}
            error={hasError}
            SelectProps={{
              MenuProps: {
                PaperProps: {
                  style: {
                    maxHeight: fetchable ? 200 : undefined,
                    width: '20ch'
                  }
                }
              }
            }}
            {...rest}
          >
            {menuItems.map(({ value, label }) => (
              <MenuItem value={value} key={value}>
                {label}
              </MenuItem>
            ))}
            {fetchable && menuItems.length > 0 ? (
              <Waypoint
                onEnter={() => {
                  fetchMore?.()
                }}
              >
                {fetching ? (
                  <Typography color='grey.400' style={{ paddingLeft: 16 }}>
                    Fetching...
                  </Typography>
                ) : (
                  <div />
                )}
              </Waypoint>
            ) : null}
          </TextField>
        )}
      />
      {helperText !== undefined && !hasError && (
        <FormHelperText id={`helper-text-${name}`}>{helperText}</FormHelperText>
      )}
      {error?.message !== undefined && (
        <FormHelperText
          id={`error-helper-text-${name}`}
          error
          style={{ textAlign: 'right', paddingRight: 8 }}
        >
          {error?.message}
        </FormHelperText>
      )}
    </FormControl>
  )
}
